	export const handleKeyDown = (e) => {
        if (["e", "E", "+", "-", "."].includes(e.key)) {
            e.preventDefault();
        }
    };

	export const handlePaste = (e) => {
		const pasted = e.clipboardData.getData("text");
		if (/[.\-+eE]/.test(pasted)) {
			e.preventDefault();
		}
	};

	// Shared by the dropdown/search paste handlers: blocks the browser's raw
	// insert, trims the pasted fragment, and splices it into the text input at
	// the caret. Returns { nextValue, caret } for the caller to apply however it
	// updates its input (store filter, component state, native setter, ...), or
	// null when the event isn't a paste into a text input (caller should bail).
	// Offsets are read from input.value, which is what selectionStart/End index into.
	export const getTrimmedPasteResult = (e) => {
		const input = e.target;
		if (!input || input.tagName !== 'INPUT') {
			return null;
		}
		e.preventDefault();

		const pastedText = (e.clipboardData || window.clipboardData)?.getData('text') ?? '';
		const trimmedText = pastedText.trim();

		const value = input.value || '';
		const start = input.selectionStart ?? value.length;
		const end = input.selectionEnd ?? value.length;

		return {
			nextValue: value.slice(0, start) + trimmedText + value.slice(end),
			caret: start + trimmedText.length,
		};
	};